import React from 'react';

export interface IJSONText {
  type: string;
  text: string;
  bold?: boolean;
  italic?: boolean;
}

export interface IJSONParagraph {
  type: string;
  children: IJSONText[];
}

export function renderJSONParagraphs(
  json: IJSONParagraph[] | undefined
): React.JSX.Element[] {
  if (!json) return [];
  return json.map((item) => (
    <p>
      {item.children.map((child) => {
        if (child.text === '') return <br></br>;
        let text = <>{child.text}</>;
        if (child.bold) {
          text = <strong>{text}</strong>;
        }
        if (child.italic) {
          text = <em>{text}</em>;
        }
        return text;
      })}
    </p>
  ));
}
